'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _icons = require('./icons.css');

var _icons2 = _interopRequireDefault(_icons);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Light = function Light() {
  var ua = navigator.userAgent.toLowerCase();
  var safari = false;
  if (ua.indexOf('safari') !== -1) {
    if (ua.indexOf('chrome') > -1) {
      safari = false;
    } else {
      safari = true;
    }
  }

  return _react2.default.createElement(
    'svg',
    { viewBox: '0 0 565 630', className: _icons2.default.svg },
    _react2.default.createElement(
      'linearGradient',
      { id: 'SVGID_1_', gradientUnits: 'userSpaceOnUse', x1: '-674.4025', y1: '855.2794', x2: '-674.924', y2: '854.8233', gradientTransform: 'matrix(392.389 0 0 -601.4888 265021.3438 514677.6875)' },
      _react2.default.createElement('stop', { offset: '0', style: { stopColor: '#F09420' } }),
      _react2.default.createElement('stop', { offset: '1', style: { stopColor: '#E32365' } })
    ),
    _react2.default.createElement('path', { className: _icons2.default.light1, style: { fill: safari ? '#F09420' : 'url(#SVGID_1_)' }, d: 'M247.2,629.3c-30.2,0-54.9-24.4-55.2-54.6H50.5v-0.5c0-108.5,88.2-196.8,196.7-196.8s196.7,88.3,196.7,196.8 v0.5H302.4C302.1,604.8,277.4,629.3,247.2,629.3z M193,574.7c0.3,29.6,24.5,53.6,54.2,53.6c29.7,0,53.9-24,54.2-53.6H193z M302.4,573.7h140.5c-0.3-107.7-88-195.3-195.7-195.3c-107.7,0-195.4,87.5-195.7,195.3H192v-0.1h110.4V573.7z M247.7,377.2h-1v-350 h1V377.2z' }),
    _react2.default.createElement(
      'linearGradient',
      { id: 'SVGID_2_', gradientUnits: 'userSpaceOnUse', x1: '-673.525', y1: '854.9449', x2: '-674.3439', y2: '854.1638', gradientTransform: 'matrix(251.1094 0 0 -354.8665 169637.0938 303568.6875)' },
      _react2.default.createElement('stop', { offset: '0', style: { stopColor: '#F09420' } }),
      _react2.default.createElement('stop', { offset: '1', style: { stopColor: '#E32365' } })
    ),
    _react2.default.createElement('path', { className: _icons2.default.light2, style: { fill: safari ? '#F09420' : 'url(#SVGID_2_)' }, d: 'M438.6,382.4c-19.4,0-35.2-15.6-35.5-34.9h-90.5v-0.5c0-69.4,56.3-125.8,125.6-126.1V27h1v193.8 c69.3,0.3,125.6,56.7,125.6,126.1v0.5h-90.5C473.8,366.7,457.9,382.4,438.6,382.4z M404,347.4c0.3,18.8,15.7,33.9,34.5,33.9 s34.2-15.2,34.5-33.9H404z M474.1,346.4h89.5c-0.3-68.6-56-124.3-124.6-124.6v0.1h-1v-0.1c-68.6,0.3-124.3,56-124.6,124.6H403v-0.1 L474.1,346.4L474.1,346.4z' }),
    _react2.default.createElement(
      'linearGradient',
      { id: 'SVGID_3_', gradientUnits: 'userSpaceOnUse', x1: '-671.7906', y1: '855.1089', x2: '-673.005', y2: '853.8271', gradientTransform: 'matrix(173.1095 0 0 -218.7453 116519.1094 187048.9688)' },
      _react2.default.createElement('stop', { offset: '0', style: { stopColor: '#F09420' } }),
      _react2.default.createElement('stop', { offset: '1', style: { stopColor: '#E32365' } })
    ),
    _react2.default.createElement('path', { className: _icons2.default.light3, style: { fill: safari ? '#F09420' : 'url(#SVGID_3_)' }, d: 'M87.6,246.2c-13.4,0-24.3-10.8-24.6-24.1H0.5v-0.5c0-47.9,38.8-86.8,86.6-87.1V27h1v107.6 c47.8,0.3,86.6,39.2,86.6,87.1v0.5h-62.4C111.9,235.5,101,246.2,87.6,246.2z M63.9,222.2c0.3,12.8,10.8,23.1,23.6,23.1 c12.8,0,23.3-10.3,23.6-23.1H63.9z M112.2,221.2h61.4c-0.3-47.2-38.8-85.6-86.1-85.6S1.8,173.9,1.5,221.2h61.4v-0.1L112.2,221.2 L112.2,221.2z' }),
    _react2.default.createElement('rect', { x: '52', y: '-1', style: { fill: '#141418' }, width: '430', height: '28' }),
    _react2.default.createElement(
      'linearGradient',
      { id: 'SVGID_4_', gradientUnits: 'userSpaceOnUse', x1: '-674.9165', y1: '847.6863', x2: '-675.2726', y2: '840.3825', gradientTransform: 'matrix(430 0 0 -28 290484 23744)' },
      _react2.default.createElement('stop', { offset: '0', style: { stopColor: '#F09420' } }),
      _react2.default.createElement('stop', { offset: '1', style: { stopColor: '#E32365' } })
    ),
    _react2.default.createElement('path', { className: _icons2.default.light4, style: { fill: safari ? '#F09420' : 'url(#SVGID_4_)' }, d: 'M482,29H50V-1h432V29z M52,27h428V1H52V27z' })
  );
};

exports.default = Light;


//////////////////
// WEBPACK FOOTER
// ./src/components/Technical/Light.js
// module id = 336
// module chunks = 1